<template>
  <div class="container-fluid">
    <vue-mermaid  class='mermaid align-items-center d-flex justify-content-center' :nodes="data" type="graph LR" @nodeClick="editNode"></vue-mermaid>
  </div>
</template>

<script>
  import BaseService from "../../_framework/api/BaseService";

  export default {
    name: "work-flowchart",
    props: {
      works: Object
    },
    components: {

    },
    data() {
      return {
        data:[
        ],

        innerWorkDetails: {},
        workDetail: [],
      }
    },
    mounted() {
      // console.log(this.works)
    },
    methods:{
      getFlowchartDetail() {
        new BaseService('CustomerOrders', `/GetOrderDetailWorks/${this.orderDetail.id}`).getList().then((response) => {
          // console.log(response.data)
          this.innerWorkDetails = response.data;
          this.workDetail = this.innerWorkDetails.works;
          this.data = this.resolveWorkStates(this.workDetail.patternStates);

        }).catch((error) => {
          console.log(error)
        })

      },
      editNode(nodeId) {
        // alert(nodeId);
      },
      getStyle(status){

        // for inQueue
        if(status === 0){
          return 'fill: #FFC107,stroke: #FF8F00,stroke-width:3px'
        }

        // for problem
        if(status === 1){
          return 'fill: #f44336,stroke:#c62828,stroke-width:3px'
        }

        // for doing
        if(status === 2){
          return 'fill: #CDDC39,stroke:#9E9D24,stroke-width:3px'
        }

        // for done
        if(status === 3){
          return 'fill: #03A9F4,stroke:#0277BD,stroke-width:3px'
        }

        // for confirm
        if(status === 4){
          return 'fill:#4CAF50,stroke:#2E7D32,stroke-width:3px'
        }
      },
      resolveWorkStates(workStates){
        const data = [];
        for (let w of workStates){
          if(!data.find(d=>d.id === w.id)){
            data.push({
              id: `${w.id}`,
              text: w.companyName,
              edgeType: w.workState ? 'circle' : 'default',
              style: w.workState ? this.getStyle(w.workState.status) : '',
              next: w.childs.map(c=>`${c.id}`)
            });
          }
          const childs = this.resolveWorkStates(w.childs);
          for (let c of childs){
            if(!data.find(d=>d.id === c.id)){
              data.push(c);
            }
          }
        }
        return data;
      }
    },
    computed: {

    },
    watch: {

    }
  };
</script>

<style >
  .mermaid .nodes .node .label {
    font-family: Shabnam,serif !important;
    font-weight: bold !important;
  }

</style>
